export default __webpack_public_path__ + "static/media/askas.a49c3d50.jpg";